<template>
  <div>
    <!-- 资源支持统计 -->
    <Echart :options="options" height="534px" width="100%"></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
export default {
  data() {
    return {
      options: {}
    };
  },
  components: {
    Echart
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    cdata: {
      handler(newData) {
        let pieCenter = ["50%", "55%"];
        let colorList = ["#ffcfa8", "#ff33ff", "#ff9900", "#2d84c0", "#423fae"];
        this.options = {
          title: {
            text: "资源支持统计",
            left: "center",
            top: "40",
            textStyle: {
              fontSize: "26",
              color: "#ffffff",
              fontWeight: "300",
              backgroundColor: "#082671"
            }
          },
          legend: {
            type: "scroll",
            // orient: 'vertical',
            left: "center",
            bottom: "30",
            itemHeight: 16,
            itemWidth: 16,
            data: newData.data
          },
          series: [
            // 主要展示层的
            {
              radius: ["0%", "50%"],
              center: pieCenter,
              type: "pie",
              itemStyle: {
                normal: {
                  color: function(params) {
                    return colorList[params.dataIndex];
                  }
                }
              },
              labelLine: {
                normal: {
                  show: true,
                  length: 15,
                  length2: 120,
                  lineStyle: {
                    color: "#d3d3d3"
                  },
                  align: "right"
                },
                color: "#000",
                emphasis: {
                  show: true
                }
              },
              label: {
                normal: {
                  formatter: function(params) {
                    var str =
                      "{nameStyle|" +
                      params.name +
                      " }" +
                      "{rate|" +
                      params.value +
                      "%}";
                    return str;
                  },
                  padding: [0, -110],
                  height: 45,
                  rich: {
                    nameStyle: {
                      fontSize: 14,
                      color: "#ccc",
                      align: "left"
                    },
                    rate: {
                      fontSize: 14,
                      color: "#ccc",
                      align: "left"
                    }
                  }
                }
              },
              data: newData.data
            },
            // 边框的设置
            {
              radius: ["47%", "51%"],
              center: pieCenter,
              type: "pie",
              label: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              labelLine: {
                normal: {
                  show: false
                },
                emphasis: {
                  show: false
                }
              },
              animation: false,
              tooltip: {
                show: false
              },

              itemStyle: {
                normal: {
                  color: "rgba(250,250,250,1)"
                }
              },
              data: [
                {
                  value: 1
                }
              ]
            }
          ]
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>
